/**
 * @file schedule.js
 *
 * Schedule API Service
 *
 * API calls to /api/v1/schedule.
 * Manages weekly availability slots for professionals.
 */
import api from "./api";

export const scheduleService = {
  /** Get the logged-in professional's weekly schedule. */
  getMe: () => api.get("/schedule/me"),
  /** View any professional's schedule by ID. */
  getByProfessional: (id) => api.get(`/schedule/professional/${id}`),
  /** Create a new weekly time slot. */
  create: (data) => api.post("/schedule/create", data),
  /** Update an existing time slot. */
  update: (id, data) => api.put(`/schedule/${id}`, data),
  /** Delete a time slot. */
  remove: (id) => api.delete(`/schedule/${id}`),
  /** Get computed available appointment slots for a professional on a specific date. */
  getAvailableSlots: (professionalId, date) =>
    api.get(`/schedule/available-slots?professionalId=${professionalId}&date=${date}`),
};
